import { InteractivityEditorService } from './../../services/interactivity-editor.service';
import { Component, Input, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';

import { IWidget } from '../../interfaces/IWidget';
import { TrackComponent } from './track.component';
import { Publication } from 'app/interfaces/publication';
import { Subscription } from 'rxjs';
import { PublicationService } from '../../../../../services/publication.service';

@Component({
	selector: 'track-element',
	templateUrl: './track-element.component.html',
	styleUrls: ['./track-element.component.scss']
})

export class TrackElementComponent implements OnInit, OnDestroy {
	@ViewChild('leftDragger') leftDragger: ElementRef;
	@ViewChild('rightDragger') rightDragger: ElementRef;

	@Input() widget: IWidget;

	baseUrl: string;
	private subscriptions = new Subscription();

	constructor(
		public interactivityEditorService: InteractivityEditorService,
		public trackComponent: TrackComponent,
		private publicationService: PublicationService) {

	}

	ngOnInit() {
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.baseurl) {
				this.baseUrl = publication.baseurl;
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
